import React from 'react'
import SectionTitle from './SectionTitle'

export default function About() {
    return (
        <section className="print-avoid-break">
            <SectionTitle title="About" />
            <div className="mt-4 font-body text-neutral-700 leading-relaxed space-y-4">
                <p>
                    Senior Engineering Leader and AI Solutions Architect who turns complex technical problems into shipped systems and measurable business outcomes. After more than a decade building and scaling platforms that have saved companies millions, I now run <span className="font-medium text-primary">Betabit</span>, where accountability isn't a buzzword—it's how we deliver.
                </p>
                <p>
                    My track record: zero-downtime AWS migrations cutting cloud costs 25–40%, data platforms reducing delivery from months to days, engineering orgs scaled 150% without losing velocity. I work across cloud architecture, data platforms, and AI-enabled systems—staying hands-on, writing production code alongside the teams I lead.
                </p>
                <p>
                    Today I focus on AI-assisted internal platforms that change how teams work—embedding AI into real workflows for data onboarding, transformation, and decision support while maintaining correctness and human control.
                </p>
                <p>
                    Engineer who codes daily, leader who's operated at org scale. I bridge strategy and execution.
                </p>
            </div>
        </section>
    )
}
